import * as datastore from '@/datastore'

export interface Category_PantryItem extends datastore.Reference {
	categoryId: string
	pantryItemId: string
}

export const defaultCategory_PantryItem: Readonly<Category_PantryItem> = {
	$id: '',
	categoryId: '',
	pantryItemId: '',
}
